/**
 * HTML 实体解码 + 去除 HTML 标签，用于纯文本展示场景
 * （如新闻列表摘要、标题），避免 &nbsp; 等实体原样显示在页面上。
 */
export function stripHtml(str) {
  if (!str) return '';
  const text = String(str).replace(/<[^<>]+>/g, '');
  const el = document.createElement('textarea');
  el.innerHTML = text;
  return el.value;
}
